export default __webpack_public_path__ + "static/media/028-olive oil.07720c65.svg";